module.exports = __webpack_public_path__ + "img/af3db7e47da34c9fbf4aaad22073a757-1440.f0c28df6.jpg";